import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchNotifications } from '../../lib/api';

export function useNotifications(userId, pageSize = 10) {
  return useQuery({
    queryKey: queryKeys.notifications(userId),
    queryFn: () => fetchNotifications(pageSize),
    enabled: !!userId,
  });
}
